<style lang="scss" scoped>
.dropdown-menu::after,
.dropdown-menu::before {
  content: none;
}
</style>

<template>
  <td>
    <div
      v-if="!model.deleted_at"
      ref="dropdown"
      class="dropdown"
      :class="{ show: show, dropup: index > 10, dropleft: true }"
    >
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <a target="_blank" class="dropdown-item" :href="model.url">
          Profil
        </a>
        <div @click="$modal.show(giveCurrencyModalName)" class="dropdown-item">
          {{ currency }} bewilligen
        </div>
        <div
          @click="$modal.show(manualTransactionModalName)"
          class="dropdown-item"
        >
          Zahlung manuell eintragen
        </div>
        <div
          @click="toggleuserDisabled"
          :disabled="settingUserDisabled"
          class="dropdown-item"
        >
          {{ userDisabledText }}
        </div>
        <div
          @click="showDisableModal"
          :disabled="isDisabled || settingUserDisabled"
          class="dropdown-item"
        >
          Profil sperren mit Begründung
        </div>
        <div @click="deleteUser()" :disabled="deleting" class="dropdown-item">
          Profil löschen
        </div>
        <div
          @click="$modal.show(messageFromSupportModalName)"
          class="dropdown-item"
        >
          Nachricht schreiben von SupportProfile
        </div>
        <div
          @click="$modal.show(messageFromFakeModalName)"
          class="dropdown-item"
        >
          Nachricht schreiben von Fake
        </div>
      </div>
    </div>
    <modal :name="giveCurrencyModalName">
      <section class="p-3">
        <h2>{{ currency }} für {{ model.name }}</h2>
        <div class="form-group">
          <input
            type="number"
            max="32767"
            class="form-control"
            name="amount"
            v-model="giveCurrencyAmount"
            :placeholder="`Wie viele ${currency} sollen gutgeschrieben werden?`"
          />
        </div>
        <button
          @click="giveCurrency()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          {{ currency }} ausgeben
        </button>
      </section>
    </modal>
    <manual-transaction-modal
      :name="manualTransactionModalName"
      :model="model"
    ></manual-transaction-modal>
    <modal :name="blockUserModalName">
      <section class="p-3">
        <h2>Sperren von {{ model.name }}</h2>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="message"
            v-model="disableMessage"
            :placeholder="`Nachricht die geblockten Nutzer angezeigt wird.`"
          />
        </div>
        <button
          @click="disableUser()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Sperren
        </button>
      </section>
    </modal>
    <modal :name="messageFromSupportModalName">
      <section class="p-3">
        <div class="form-group">
          <textarea
            class="form-control"
            placeholder="Nachricht ..."
            v-model="supportMessage"
          ></textarea>
        </div>
        <button
          @click="sendSupportMessage()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Senden
        </button>
      </section>
    </modal>
    <modal :name="messageFromFakeModalName">
      <section class="p-3">
        <div class="form-group">
          <input
            type="number"
            class="form-control"
            placeholder="Fake Profile ID"
            v-model="fakeID"
          />
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            placeholder="Nachricht ..."
            v-model="supportMessage"
          ></textarea>
        </div>
        <button
          @click="sendMessageFromFake()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Senden
        </button>
      </section>
    </modal>
  </td>
</template>

<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";
import manualTransactionModal from "@/components/modals/ManualTransactionModal";

export default {
  props: ["model", "tableId", "index"],
  components: {
    manualTransactionModal
  },
  data() {
    return {
      show: false,
      giveCurrencyAmount: 0,
      disableModalActions: false,
      disableMessage: "",
      fakeID: 1,
      supportMessage: "",
      settingUserDisabled: false,
      deleting: false
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  methods: {
    showDisableModal() {
      if (this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.show = false;
      this.$modal.show(this.blockUserModalName);
    },
    giveCurrency() {
      this.disableModalActions = true;
      this.$http
        .post("/api/v1/admin-actions/give-currency", {
          customer_profile_id: this.model.id,
          amount: this.giveCurrencyAmount
        })
        .then(() => {
          this.$modal.hide(this.giveCurrencyModalName);
          this.$notify({
            title: `${this.model.name} hat ${this.giveCurrencyAmount} ${this.currency} erhalten`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
        });
    },

    toggleuserDisabled() {
      this.show = false;

      if (this.isDisabled) {
        this.enableUser();
      } else {
        this.disableUser();
      }
    },
    disableUser() {
      if (this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.settingUserDisabled = true;

      this.$http
        .post("/api/v1/userDisabled", {
          user_id: this.model.user.id,
          message: this.disableMessage.length === 0 ? null : this.disableMessage
        })
        .then(({ data }) => {
          this.$store.commit("table/updateModel", {
            tableId: this.tableId,
            modelId: this.model.id,
            attributePath: "user.disabled_at",
            data: data
          });

          this.$notify({
            title: `${this.model.name} wurde gesperrt`,
            type: "success"
          });
        })
        .catch(() => {
          this.$emit("table-update");
        })
        .finally(() => {
          this.disableModalActions = false;
          this.show = false;
          this.settingUserDisabled = false;
          this.$modal.hide(this.blockUserModalName);
        });
    },
    enableUser() {
      if (!this.isDisabled || this.settingUserDisabled) {
        return;
      }

      this.settingUserDisabled = true;

      this.$http
        .delete(`/api/v1/userDisabled/${this.model.user.id}`)
        .then(() => {
          this.$store.commit("table/updateModel", {
            tableId: this.tableId,
            modelId: this.model.id,
            attributePath: "user.disabled_at",
            data: undefined
          });
          this.$notify({
            title: `${this.model.name} wurde entsperrt`,
            type: "success"
          });
        })
        .catch(() => {
          this.$emit("table-update");
        })
        .finally(() => {
          this.disableModalActions = false;
          this.show = false;
          this.settingUserDisabled = false;
        });
    },
    deleteUser() {
      let confirmed = confirm(
        `Willst du wirklich "${this.model.name}" löschen?`
      );
      if (!confirmed) {
        return;
      }

      this.deleting = true;

      this.$http
        .post("/api/v1/admin-actions/delete/user/" + this.model.user_id)
        .then(() => {
          this.$notify({
            title: `${this.model.name} wurde gelöscht`,
            type: "success"
          });
        })
        .finally(() => {
          this.$emit("table-update", { count: true });
          this.show = false;
          this.deleting = false;
        });
    },
    sendSupportMessage() {
      this.disableModalActions = true;
      this.$store
        .dispatch("message/create", {
          url: "/api/v1/message",
          data: {
            body: this.supportMessage,
            receiver_id: this.model.id,
            sender_id: Laravel.support.id,
            type: 5
          }
        })
        .then(() => {
          this.$notify({
            title: `${this.model.name} hat eine Support Nachricht erhalten`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
          this.$emit("table-update");
          this.show = false;
          this.$modal.hide(this.messageFromSupportModalName);
        });
    },
    sendMessageFromFake() {
      this.disableModalActions = true;
      this.$http
        .post("/api/v1/admin-actions/fake-message/" + this.model.id, {
          fake_id: this.fakeID,
          message: this.supportMessage
        })
        .then(() => {
          this.$notify({
            title: `${this.model.name} hat eine Nachricht von Fake ${this.fakeID} erhalten`,
            type: "success"
          });
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$notify({
              title: error.response.data,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.disableModalActions = false;
          this.$emit("table-update");
          this.show = false;
          this.$modal.hide(this.messageFromFakeModalName);
        });
    }
  },
  computed: {
    currency() {
      return Laravel.lang.currency;
    },
    modalPrefix() {
      return this.model.id;
    },
    giveCurrencyModalName() {
      return `${this.modalPrefix}-give-currency`;
    },
    manualTransactionModalName() {
      return `${this.modalPrefix}-manual-payment`;
    },
    blockUserModalName() {
      return `${this.modalPrefix}-block-user`;
    },
    messageFromSupportModalName() {
      return `${this.modalPrefix}-message-from-support`;
    },
    messageFromFakeModalName() {
      return `${this.modalPrefix}-message-from-fake`;
    },
    isDisabled() {
      return Boolean(this.model.user.disabled_at);
    },
    userDisabledText() {
      return this.isDisabled ? "Profil entsperren" : "Profil sperren";
    }
  }
};
</script>
